import { Button } from "@sellar-io/components";
import {
  SupplierRelationshipListResponseType,
  SupplierRelationshipPaymentDueCalculateFromType,
} from "@sellar-io/api-v2/types";
import { useSupplierRelationshipPaymentTermsRequestUpdate } from "../../hooks/api/v2/supplierRelationshipPaymentTermsRequest/useSupplierRelationshipPaymentTermsRequestUpdate";
import { Alert } from "../alert/Alert";
import { ConnectionPaymentTermsRequestIndicatorChange } from "./ConnectionPaymentTermsRequestIndicatorChange";

export const RequestedCreditTermsAlert = ({
  connection,
  requestedPaymentTerms,
  onSuccess,
  buyerName,
  orderId,
}: {
  connection: Pick<
    SupplierRelationshipListResponseType[number],
    | "paymentTerms"
    | "paymentDueCalculateFrom"
    | "paymentDue"
    | "PaymentTermsRequest"
  >;
  buyerName: string;
  requestedPaymentTerms: {
    id: number;
    paymentDue: number;
    paymentDueCalculateFrom: SupplierRelationshipPaymentDueCalculateFromType;
    status: "pending" | "accepted" | "rejected";
  };
  onSuccess?: (message: string) => void;
  orderId?: number;
}) => {
  const connectionPaymentTermsRequestUpdateMutation =
    useSupplierRelationshipPaymentTermsRequestUpdate(requestedPaymentTerms.id);

  const onSubmit = (status: "rejected" | "accepted") => {
    const message =
      status === "rejected"
        ? "Credit terms request dismissed"
        : "Credit terms updated";
    return connectionPaymentTermsRequestUpdateMutation.mutate(
      {
        status,
        ...(orderId && {
          OrderId: orderId,
        }),
      },
      {
        onSuccess: () => onSuccess?.(message),
      },
    );
  };
  const loading = connectionPaymentTermsRequestUpdateMutation.isPending;
  return (
    <Alert
      title={"Credit terms requested"}
      message={`${buyerName} has requested to use credit. You can assign their chosen credit terms which are stated below, or you can deny their request to keep their original terms`}
    >
      <div className="flex flex-col gap-4">
        <ConnectionPaymentTermsRequestIndicatorChange
          connection={{
            ...connection,
          }}
        />
        <div className="flex flex-row gap-2">
          <Button
            disabled={loading}
            loading={loading}
            color={"secondary"}
            onClick={() => onSubmit("accepted")}
          >
            Assign terms
          </Button>
          <Button
            disabled={loading}
            loading={loading}
            color={"tertiary"}
            onClick={() => onSubmit("rejected")}
          >
            Deny request
          </Button>
        </div>
      </div>
    </Alert>
  );
};
